<div [formGroup]="researcherCertificateForm" fxLayout="column">
  <div *ngIf="generalError" class="mat-error">
    {{generalError.message}}
  </div>

  <mat-form-field>
    <mat-label>Creation Date </mat-label>

    <input formControlName="creationDate" readonly (focusin)="creationDatePicker.open()"
      [matDatepicker]="creationDatePicker" [max]="researcherCertificateForm.controls['endDate']?.value" matInput
      name="creationDate">
    <mat-datepicker-toggle [for]="creationDatePicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker-toggle matSuffix (click)="researcherCertificateForm.controls.creationDate.setValue(null)">
      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
    </mat-datepicker-toggle>

    <mat-datepicker #creationDatePicker></mat-datepicker>

    <mat-error
      *ngIf="researcherCertificateForm.controls.creationDate?.errors?.pattern && !researcherCertificateForm.controls.creationDate?.errors?.required">
      Please enter a valid creation date
    </mat-error>
    <mat-error *ngIf="researcherCertificateForm.controls.creationDate?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>End Date </mat-label>

    <input formControlName="endDate" readonly (focusin)="endDatePicker.open()" [matDatepicker]="endDatePicker"
      [min]="researcherCertificateForm.controls['creationDate']?.value" matInput name="endDate">
    <mat-datepicker-toggle [for]="endDatePicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker-toggle matSuffix (click)="researcherCertificateForm.controls.endDate.setValue(null)">
      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>


    <mat-error
      *ngIf="researcherCertificateForm.controls.endDate?.errors?.pattern && !researcherCertificateForm.controls.endDate?.errors?.required">
      Please enter a valid end date
    </mat-error>
    <mat-error *ngIf="researcherCertificateForm.controls.endDate?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <ng-container *ngIf="!isEditing">
    <mat-form-field>
      <mat-label>Researcher </mat-label>
      <mat-select [(value)]="selectedResearcher" [disabled]="isEditing" formControlName="researcher" name="researcher">
        <mat-option *ngIf="!loadingResearchers && researchers.length === 0">
          No researchers available.
        </mat-option>
        <mat-option *ngFor="let researcher of researchers" [value]="researcher">
          {{researcher.firstName}} {{researcher.lastName}}
        </mat-option>
      </mat-select>
      <span *ngIf="loadingResearchers" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
      <mat-hint *ngIf="!loadingResearchers && researchers.length === 0" class="color-warn">
        No researchers available.
      </mat-hint>
    </mat-form-field>
  </ng-container>

  <mat-form-field>
    <mat-label>cmId </mat-label>
    <input formControlName="cmId" matInput name="cmId" type="text">
    <mat-error *ngIf="researcherCertificateForm.controls.cmId?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="certificate = _certificate; canceled.emit()" mat-button>Cancel</button>
    <button (click)="saveResearcherCertificate()" [disabled]="researcherCertificateForm.invalid || saving "
      color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>